module.exports = __webpack_public_path__ + "static/media/ComeFunziona.29bb5248.jpg";